import {IHandler, IWrapper} from '../types';

/**
 * Wrapper class to handle API requests
 */
class Wrapper implements IWrapper {
  protected apiURL: string;
  handler: IHandler;
  /**
   * Constructor
   * @param apiURL
   * @param handler
   */
  constructor(apiURL: string, handler: IHandler) {
    this.apiURL = apiURL;
    this.handler = handler;
  }

  /**
   * Get complete path url
   * @param pathURL ex: '/getPortalConfig'
   * @return API_URL/:PATH_URL (ex: https://apiurl.com/api/v1/getPortalConfig)
   */
  readonly getCompleteURL = (pathURL: string) => {
    return `${this.apiURL}${pathURL}`;
  };

  /**
   * Generic GET request method
   * @param path
   * @param params
   */
  public async get<T>(path: string, params?: object): Promise<T> {
    const request = {
      method: 'GET',
      url: this.getCompleteURL(path),
      headers: this.handler.getHeaders(),
      params: params,
    };
    return await this.handler.requestHandler(request);
  }

  /**
   * Generic POST request method
   * @param path
   * @param data request body
   */
  public async post<T>(path: string, data: object): Promise<T> {
    const request = {
      method: 'POST',
      url: this.getCompleteURL(path),
      headers: this.handler.getHeaders(),
      data: data,
    };
    return await this.handler.requestHandler(request);
  }

  /**
   * Generic PUT request method
   * @param path
   * @param data request body
   */
  public async put<T>(path: string, params?: object): Promise<T> {
    const request = {
      method: 'PUT',
      url: this.getCompleteURL(path),
      headers: this.handler.getHeaders(),
      params: params,
    };
    return await this.handler.requestHandler(request);
  }

  /**
   * Generic PATCH request method
   * @param path
   * @param data request body
   */
  public async patch<T>(path: string, data: object): Promise<T> {
    const request = {
      method: 'PATCH',
      url: this.getCompleteURL(path),
      headers: this.handler.getHeaders(),
      data: data,
    };
    return await this.handler.requestHandler(request);
  }

  /**
   * Generic DELETE request method
   * @param path
   */
  public async delete<T>(path: string): Promise<T> {
    const request = {
      method: 'DELETE',
      url: this.getCompleteURL(path),
      headers: this.handler.getHeaders(),
    };
    return await this.handler.requestHandler(request);
  }
}

export default Wrapper;
